import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Approach", id: "approach" },
    { label: "Contact", id: "contact" },
  ];

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF8F5]/95 backdrop-blur-md border-b border-[#D1B981]/30 py-4"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        {/* Logo */}
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="bg-transparent border-none cursor-pointer p-0"
        >
          <span
            className="tracking-[0.25em] text-lg md:text-xl"
            style={{
              fontFamily: "var(--font-serif)",
              fontWeight: 600,
              color: "var(--text-primary)",
            }}
          >
            VALTOR CAPITAL
          </span>
        </button>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              onClick={() => scrollTo(link.id)}
              className="nav-link bg-transparent border-none cursor-pointer p-0"
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="nav-enquire-btn"
            onClick={() => scrollTo("contact")}
            className="btn-enquire"
          >
            Enquire
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden bg-transparent border-none cursor-pointer p-1"
          style={{ color: "var(--text-primary)" }}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden absolute top-full left-0 w-full bg-[#FAF8F5] border-b border-[#E5DED5] py-6 px-6"
        >
          <div className="flex flex-col gap-5">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`mobile-nav-link-${link.id}`}
                onClick={() => scrollTo(link.id)}
                className="nav-link bg-transparent border-none cursor-pointer p-0 text-left"
              >
                {link.label}
              </button>
            ))}
            <button
              data-testid="mobile-enquire-btn"
              onClick={() => scrollTo("contact")}
              className="btn-enquire w-fit mt-2"
            >
              Enquire
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};
